module.exports = __webpack_public_path__ + "static/logoDataboxBlack-6af4932708a83dc634d9ef4914ec381a.png";